import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button, Col, Divider, Modal, Row } from 'antd';
import { deletePortfolio } from '../../data/store/portfolio/portfolioActions';

const ModalDeletePortfolio = ({
  modalDeleteVisible,
  setModalDeleteVisible,
  portfolioId,
  userId,
  name,
  is_composite,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const portfolioList = useSelector(
    (state) => state.portfolioReducer?.portfolioList?.list,
  );

  const handleCloseDelModal = () => {
    setModalDeleteVisible(false);
  };

  const isCompositeItem = useMemo(() => {
    if (portfolioList?.length && !is_composite) {
      const composite = portfolioList?.find((i) => i.is_composite);
      return composite?.composites?.includes(+portfolioId);
    } else {
      return false;
    }
  }, [portfolioList, portfolioId, is_composite]);

  const submitDelete = () => {
    dispatch(
      deletePortfolio({
        history,
        portfolioId,
        clientId: +userId,
      }),
    );
    setModalDeleteVisible(false);
  };

  return (
    <Modal
      width={700}
      className="modal-content-paper"
      open={modalDeleteVisible}
      onCancel={handleCloseDelModal}
      centered
      footer={null}
      zIndex={1600}
    >
      <Row justify="start">
        <Col className="modal-title">{t('MODAL_DELETE_TITLE')}</Col>
      </Row>
      <Divider className="modal-divider" />
      {is_composite ? (
        <Row justify="start" className="modal-text-wrapper">
          <Col>
            <p className="modal-description">{t('MODAL_DELETE_PORTFOLIO')}</p>
            <p className="modal-name">{name}</p>
          </Col>
        </Row>
      ) : (
        <Row justify="start" className="modal-text-wrapper">
          <Col>
            <p className="modal-description">
              {t(
                isCompositeItem
                  ? 'LOCKED_PORTFOLIO_DELETE'
                  : 'MODAL_DELETE_PORTFOLIO',
              )}
            </p>
            <p className="modal-name">{name}</p>
          </Col>
        </Row>
      )}
      <Row justify="end" style={{ marginTop: '50px' }}>
        <Col>
          <Button
            className="modal-action-btn cancel-btn"
            onClick={handleCloseDelModal}
          >
            {t('CANCEL')}
          </Button>
          <Button
            style={{ marginLeft: '8px' }}
            className="modal-action-btn delete-btn"
            disabled={isCompositeItem}
            onClick={submitDelete}
          >
            {t('DELETE')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalDeletePortfolio;

ModalDeletePortfolio.propTypes = {
  modalDeleteVisible: PropTypes.bool.isRequired,
  setModalDeleteVisible: PropTypes.func.isRequired,
  portfolioId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  is_composite: PropTypes.bool,
};
